import {combineReducers} from '@reduxjs/toolkit';

import {userEntitlementsAssignedReducer} from './assigned/user-entitlement-assigned.reducer';
import {userDatasetEntitlementsAssignedReducer} from './dataset/user-dataset-entitlements.reducer';
import {mcpUserEntitlementsAssignedReducer} from './mcp/mcp-user-entitlement-assigned.reducer';

export const userEntitlementsReducer = combineReducers({
    assigned: userEntitlementsAssignedReducer,
    dataset: userDatasetEntitlementsAssignedReducer,
    mcp: mcpUserEntitlementsAssignedReducer,
});
